import { useLocation, useNavigate } from 'react-router-dom'

import { Box, Button, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'
import companies from 'modules/core/store/collections/companies'

import { companyInExpiredFreeTrial } from 'modules/billing/store/collections/subscriptions'

interface Props {
  dayCount: number
}

const UpgradeBanner = ({ dayCount }: Props) => {
  const current = companies.current
  const { pathname } = useLocation()
  const { navigation } = useNavigation()
  const navigate = useNavigate()

  const noExpiredLabel = i18n.tp('end_of_trial.banner_copy.not_expired', { count: dayCount })
  const expiredLabel = i18n.t('end_of_trial.banner_copy.expired')

  const trackGoToPricingPlans = () => {
    track(trackingEvents.billing.goToPricingPlans, {
      page_path: pathname,
      from: 'announcement_banner_button',
    })
  }

  const onClickBanner = () => {
    trackGoToPricingPlans()
    navigate(navigation.upgradePlan.path)
  }

  return (
    <>
      <Box
        flexDirection="row"
        padding="s8"
        width="full"
        style={{
          background: 'linear-gradient(90deg, #D14A58 15%, #D03590 50%, #D2282F 85%)',
        }}
        justifyContent="center"
        alignItems="center"
        gap="s12"
        onClick={onClickBanner}
        cursor="pointer"
      >
        <Text.Normal color="grey000White" weight="semibold">
          {companyInExpiredFreeTrial(current) ? expiredLabel : noExpiredLabel}
        </Text.Normal>
        <Button.Router
          to={navigation.upgradePlan.path}
          onClick={trackGoToPricingPlans}
          type="primary"
        >
          {i18n.t('pricing_plans.page_title')}
        </Button.Router>
      </Box>
    </>
  )
}

export default observer(UpgradeBanner)
